// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4850":"1dee9725","5140":"5c2a3d57"}[chunkId] + ".chunk.css";
};